import $, { css, get } from "jquery";
// import "@fancyapps/fancybox";
// import "magnific-popup";
import SignaturePad from "signature_pad";
// import Swiper from "swiper/bundle";
// import "masonry-layout/dist/masonry.pkgd.min.js";
// import 'isotope-layout/dist/isotope.pkgd.min.js';

$(function ($) {
  // console.log("Plugin Work");

  /** ==================================================================
   *  Contract
   * =====================================================================*/

  /** Test Functionality */
  $("#generate-pdf")
    .off("click")
    .on("click", function () {
      const userId = $(this).data("user-id");

      if (!userId) {
        alert("User ID is missing.");
        return;
      }

      $.ajax({
        url: ajaxObject.ajax_url,
        type: "POST",
        data: {
          action: "generate_signed_pdf",
          user_id: userId,
        },
        success: function (response) {
          if (response.success) {
            alert("PDF is zgenet!");
            $("#pdf-download-link").html(
              `<a href="${response.data.pdf_url}" target="_blank">Download the signed contract</a>`
            );
          } else {
            alert("PDF generation error: " + response.data.message);
          }
        },
        error: function () {
          alert("There was an error during the request.");
        },
      });
    });

  let isSigned = false; //Variable for verification or sign

  function openPopupAndInitSignaturePad(targeted_popup_class) {
    console.log("popup opened");

    var $popup = $('[data-popup="' + targeted_popup_class + '"]');

    $popup.fadeIn(350, function () {
      const canvas = document.getElementById("signature-pad");

      if (canvas) {
        const resizeCanvas = () => {
          const ratio = Math.max(window.devicePixelRatio || 1, 1);
          canvas.width = canvas.offsetWidth * ratio;
          canvas.height = canvas.offsetHeight * ratio;
          canvas.getContext("2d").scale(ratio, ratio);
        };

        resizeCanvas();

        const signaturePad = new SignaturePad(canvas);
        isSigned = false; //Summage the signature status when you open

        $("#clear-signature")
          .off("click")
          .on("click", function () {
            signaturePad.clear();
            // console.log("Signature cleared.");
            isSigned = false; //The user cleared the signature
            toggleCloseButton(); //Update the status of the closing button
          });
        $("#save-signature")
          .off("click")
          .on("click", function () {
            if (signaturePad.isEmpty()) {
              $("#signature-warning")
                .text("Please sign before saving to proceed.")
                .fadeIn();
              return;
            }

            $("#signature-warning").fadeOut(); // Hide warning if the signature is valid

            const dataURL = signaturePad.toDataURL("image/png");
            const userId = $("#save-signature").data("user-id");

            if (!userId) {
              $("#signature-warning").text("User ID is missing.").fadeIn();
              return;
            }

            $.ajax({
              url: ajaxObject.ajax_url,
              type: "POST",
              data: {
                action: "save_signature",
                signature: dataURL,
                user_id: userId,
              },
              success: function (response) {
                if (response.success) {
                  $("#signature-warning")
                    .text("The signature has been successfully saved!")
                    .css("color", "green")
                    .fadeIn()
                    .delay(2000)
                    .fadeOut();

                  isSigned = true;
                  toggleCloseButton();

                  // Close the popup after 3 seconds
                  setTimeout(function () {
                    closePopup("contract-popup");
                  }, 3000);
                } else {
                  $("#signature-warning")
                    .text("Signature saving failed.")
                    .css("color", "red")
                    .fadeIn();
                }
              },
              error: function () {
                $("#signature-warning")
                  .text("There was an error during the request.")
                  .css("color", "red")
                  .fadeIn();
              },
            });
          });
      }
    });

    //block the scroll
    var scrollbarWidth =
      window.innerWidth - document.documentElement.clientWidth;
    $("html").css({ "margin-right": scrollbarWidth + "px" });
    $("html").addClass("body-no-scroll-compensate");
    $("html").addClass("body-no-scroll");

    toggleCloseButton(); //Update the status of the closing button when you open
  }

  // Function to close the popup
  function closePopup(targeted_popup_class) {
    $('[data-popup="' + targeted_popup_class + '"]').fadeOut(350);

    $("html").removeClass("body-no-scroll body-no-scroll-compensate");
    $("html").css({ "margin-right": "" });
  }
  //function to turn on/off the cross closure
  function toggleCloseButton() {
    const closeButton = $("[data-popup-close]");

    if (isSigned) {
      closeButton.removeClass("disabled"); //Allow closure
      closeButton.css({ "pointer-events": "auto", opacity: "1" });
    } else {
      closeButton.addClass("disabled"); //Prohibit closure
      closeButton.css({ "pointer-events": "none", opacity: "0.5" });
    }
  }

  //Use when changing checkbox
  $(document).on("change", "#contract_agreement", function () {
    console.log("Contract Popup Triggered");

    if ($(this).is(":checked")) {
      openPopupAndInitSignaturePad("contract-popup");
    }
  });
  $(document).on("click", "[data-popup-close]", function (e) {
    var targeted_popup_class = $(this).attr("data-popup-close");

    // Trigger the logic only for the "contract-popup"
    if (targeted_popup_class === "contract-popup") {
        // Check if the contract is signed
        if (!isSigned) {
            alert("You must sign a contract before closing.");

            // Deactivate the checkbox
            $("#contract_agreement").prop("checked", false);

            e.preventDefault();
            return;
        }

        // Fade out the popup
        $('[data-popup="' + targeted_popup_class + '"]').fadeOut(350);

        // Remove classes for scroll
        $("html").removeClass("body-no-scroll body-no-scroll-compensate");
        $("html").css({
            "margin-right": "",
        });

        e.preventDefault();
    }
});
});
